import React from 'react';
import PropTypes from 'prop-types';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export function SocialEmbed({ content = null }) {
  return <ContentFragment classes="social-embed d-flex justify-content-center">{content}</ContentFragment>;
}

SocialEmbed.propTypes = {
  content: PropTypes.string,
};
